import { Logo } from '@repo/ui/components/logo'
import type { NavigationContent } from '@/components/nav'
import { appUrl, siteBrand } from './brand'

export const navigationContent: NavigationContent = {
  brand: {
    name: siteBrand.projectName,
    logo: <Logo className="h-8 w-8" />,
  },
  links: [
    {
      type: 'simple',
      label: 'How it helps',
      href: '/#how-it-works',
    },
    {
      type: 'simple',
      label: 'What it does',
      href: '/#features',
    },
    {
      type: 'simple',
      label: 'Pricing',
      href: '/#pricing',
    },
    {
      type: 'dropdown',
      label: 'Company',
      children: [
        {
          type: 'simple',
          label: 'Blog',
          href: '/blog',
        },
        {
          type: 'simple',
          label: 'Contact',
          href: '/contact',
        },
      ],
    },
  ],
  actions: [
    {
      label: 'Sign in',
      variant: 'ghost',
      href: appUrl.signIn,
    },
    {
      label: 'Start free',
      variant: 'default',
      href: appUrl.signUp,
    },
  ],
  mobileBreakpoint: 1024,
}

export const useMenuContent = (): NavigationContent => navigationContent
